import { createAction } from '@reduxjs/toolkit';
import {
  HANDLE_BACK_NAVIGATION,
  HANDLE_SUBMIT,
  TransactionRuleType,
  TransactionRulesStages,
  UPDATE_APPLY_TO_EXISTING,
  UPDATE_DUPLICATE_ID,
  UPDATE_ERROR,
  UPDATE_RULE,
  UPDATE_STAGE,
} from './transactionRulesTypes';

export const updateRuleAction = createAction<TransactionRuleType>(UPDATE_RULE);
export const updateStageAction = createAction<TransactionRulesStages>(UPDATE_STAGE);
export const updateApplyAction = createAction<boolean>(UPDATE_APPLY_TO_EXISTING);
export const handleSubmitAction = createAction<TransactionRulesStages>(HANDLE_SUBMIT);
export const handleBackNavAction = createAction<TransactionRulesStages>(HANDLE_BACK_NAVIGATION);
export const updateDuplicateIdAction = createAction<string | undefined>(UPDATE_DUPLICATE_ID);
export const updateErrorAction = createAction<string | undefined>(UPDATE_ERROR);
